import { List, Row, Descriptions } from "antd";
import Credito from "../../../../../../Models/Financeiro/Titulo/Pagamento/Credito";
// import { ListItemTypeProps } from "antd/es/list/Item";
interface ICreditoListItemProps extends React.ComponentProps<typeof Descriptions> {
    data:Credito
}
export default function CreditoListItem({
    data,
    ...props
}:ICreditoListItemProps) {
    return <Descriptions {...props}>
        <Descriptions.Item label="Forma">{data.tipo?.nome}</Descriptions.Item>
        <Descriptions.Item label="Conta">{data.conta?.nome ?? data.codConta}</Descriptions.Item>
        <Descriptions.Item label="Parcelas">{data.quantidadeParcelas}</Descriptions.Item>
        <Descriptions.Item label="Identificador Banco">{data.identificadorProvedor}</Descriptions.Item>
        {data.identificadorProvedorCancelamento && <Descriptions.Item label="Identificador Banco (Cancelamento)">{data.identificadorProvedorCancelamento}</Descriptions.Item>}
    </Descriptions>;
}